import { WharehouseModel } from "../../models/whr/warehouse.model";
import { DireccioneModel } from "../../models/general/cliente.model";
import { ValidatorService } from "../../../control-core/services/validator-service";

export class WhrRespuestaCotizacionModel {
  productos: WhrProductoCotizacionModel[];
  errores: Array<{ producto: string, mensaje: string }>;
}

export class WhrProductoCotizacionModel {
  id: string = "";
  nombre: string = "";
  unidadpeso: string = "";
  pesoFisico: string = "";
  volumen: number = 0;
  pesoCobrar: string = "";
  total: number = 0;
  masa_id: string = "";
  longitud_id: string = "";
  tarifaminima: boolean = false;
  conceptos: PdrConceptoModel[] = Array<PdrConceptoModel>();
}

export interface IPdrConcepto {
  id: string,
  nombre: string,
  total: number
}

export class PdrConceptoModel implements IPdrConcepto {
  id: string = "";
  nombre: string = "";
  total: number = 0;
}


export class WhrCotizarDataModel {
  valorasegurado: number;
  valordeclarado: number;
  peso: number;
  alto: number;
  largo: number;
  ancho: number;
  whr_id: string = "";
  nrowhr: string = "";
  tracking: string = "";
  paqdesc: string = "";
  cupon: string = "";
  destino: DireccioneModel = new DireccioneModel();
  para_documentos: boolean = false;
  con_recogida: boolean = false;

  constructor() {
  }

  public setFromWarehouse(warehouse: WharehouseModel) {
    this.whr_id = warehouse.id;
    this.nrowhr = warehouse.nrowhr;
    this.tracking = warehouse.tracking;
    this.valorasegurado = warehouse.valorasegurado;
    this.valordeclarado = warehouse.valordeclarado;
    this.paqdesc = warehouse.paqdesc;
    this.peso = warehouse.peso;
    this.largo = warehouse.largo;
    this.ancho = warehouse.ancho;
    this.alto = warehouse.alto;

    if(!this.isEmpty(warehouse.notificacion)
        && !this.isEmpty(warehouse.notificacion.destinatario)
        && !this.isEmpty(warehouse.notificacion.desdireccion)){
      this.destino.nombres = warehouse.notificacion.destinatario.nombres;
      this.destino.telefono = warehouse.notificacion.destinatario.telefono;
      this.destino.idbox = warehouse.notificacion.destinatario.idbox;
      this.destino.apellidos = warehouse.notificacion.destinatario.apellidos;
      this.destino.direccion = warehouse.notificacion.desdireccion.direccion;
      this.destino.ciudad = warehouse.notificacion.ciudaddestino;
      this.destino.zip = warehouse.notificacion.desdireccion.zip;
      this.destino.email = warehouse.notificacion.destinatario.email;
      this.destino.geciudade_id = warehouse.notificacion.ciudad_destino_id;
      this.destino.gedestinatario_id = null;
    } else {
      this.destino.nombres = warehouse.desnombres;
      this.destino.telefono = warehouse.destelefono;
      this.destino.idbox = warehouse.desidbox;
      this.destino.apellidos = warehouse.desapellidos;
      this.destino.direccion = warehouse.desdireccion;
      this.destino.ciudad = warehouse.ciudaddes;
      this.destino.zip = warehouse.deszip;
      this.destino.email = warehouse.desemail;
      this.destino.geciudade_id = warehouse.desciudad;
      this.destino.gedestinatario_id = warehouse.desid;
    }

  }

  public generarDestinatario() {
    return {
      id: this.destino.gedestinatario_id,
      idbox: this.destino.idbox,
      nombres: this.destino.nombres,
      apellidos: this.destino.apellidos,
      email: this.destino.email,
      telefono: this.destino.telefono,
      direccion: {
        direccion: this.destino.direccion,
        zip: this.destino.zip,
        geciudade_id: this.destino.ciudad.id
      }
    };
  }

  private isEmpty = (data: any): boolean => {
    if (typeof(data) === 'object') {
      if (JSON.stringify(data) === '{}' || JSON.stringify(data) === '[]') {
        return true;
      } else if (!data) {
        return true;
      }
      return false;
    } else if (typeof(data) === 'string') {
      if (!data.trim()) {
        return true;
      }
      return false;
    } else if (typeof(data) === 'undefined') {
      return true;
    } else {
      return false;
    }
  };

}


// WEBPACK FOOTER //
// ./src/app/control-app/shared/whr-cotizar/whr-cotizar.model.ts